// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2A0MM","tab":"ProcedureTabs_tab__3B4pv"};